var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"py-3 text-center text-gray-700 md:py-2"},[_c('span',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.itemsStart)+" - "+_vm._s(_vm.itemsEnd))]),_vm._v(" of "),_c('span',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.numberOfItems))])])
}
var staticRenderFns = []

export { render, staticRenderFns }